import { defaultCssFilters } from '@components/exportable/css-filters-control/data/default-css-filters'
import { reduce } from 'lodash-es'
import { ICssFilter } from '@components/exportable/css-filters-control/interfaces/i-css-filter'
import { IColorBlindPresets } from '@components/exportable/css-filters-control/interfaces/i-color-blind-presets'
import { ICssFilterValues } from '@components/exportable/css-filters-control/interfaces/i-css-filter-values'
import { TCssFilter } from '@components/exportable/css-filters-control/types/t-css-filter'

const defaultCssFilterValues: ICssFilterValues = reduce(
  defaultCssFilters,
  (acc: Partial<ICssFilterValues>, v: ICssFilter, k: string) => {
    acc[k as TCssFilter] = v.value
    return acc
  },
  {},
) as ICssFilterValues

export const colorBlindPresets: IColorBlindPresets = {
  protanopia: {
    ...defaultCssFilterValues,
    'hue-rotate': 270,
    invert: 100,
    saturate: 200,
  },
  deuteranopia: {
    ...defaultCssFilterValues,
    'hue-rotate': 280,
    invert: 100,
    saturate: 200,
  },
  tritanopia: {
    ...defaultCssFilterValues,
    'hue-rotate': 180,
    invert: 100,
    saturate: 200,
  },
  achromatopsia: {
    ...defaultCssFilterValues,
    contrast: 120,
    saturate: 200,
    grayscale: 100,
  },
}
